import React, { createContext, useContext, useEffect, useState } from "react";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
	const [token, setToken] = useState(() => localStorage.getItem("authToken") || null);
	const [user, setUser] = useState(() => {
		const raw = localStorage.getItem("authUser");
		return raw ? JSON.parse(raw) : null;
	});

	function login(t, u) {
		setToken(t);
		setUser(u);
		localStorage.setItem("authToken", t);
		localStorage.setItem("authUser", JSON.stringify(u));
	}

	function logout() {
		setToken(null);
		setUser(null);
		localStorage.removeItem("authToken");
		localStorage.removeItem("authUser");
	}

	const value = { token, user, login, logout, isAuthenticated: !!token };
	return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function useAuth() {
	return useContext(AuthContext);
}
